import React, { useCallback } from 'react';
import { useDropzone, DropzoneOptions, FileRejection } from 'react-dropzone';
import UploadIcon from '../../../assets/icon-upload.svg?react';
import { DEFAULT_MAX_SIZE } from '../../../config/settings';
import notify from '@/services/notify';

interface FileUploadSectionProps {
  maxFiles?: number;
  accept?: DropzoneOptions['accept'];
  maxSize?: number;
  multiple?: boolean;
  onFilesAccepted: (acceptedFiles: File[]) => void;
  errorMsg?: string;
  infoMsg?: string;
  fileFormatExtensionsText?: string;
}

const FileUploadSection: React.FC<FileUploadSectionProps> = ({
  maxFiles = 1,
  accept,
  maxSize = DEFAULT_MAX_SIZE,
  multiple = false,
  onFilesAccepted,
  errorMsg = 'Please upload a valid file.',
  infoMsg,
  fileFormatExtensionsText,
}) => {
  const onDrop = useCallback(
    (acceptedFiles: File[], fileRejections: FileRejection[]) => {
      if (fileRejections.length > 0) {
        notify({
          message: errorMsg,
          type: 'error',
        });
        return;
      }
      if (acceptedFiles && acceptedFiles.length > 0) {
        onFilesAccepted(acceptedFiles);
      }
    },
    [onFilesAccepted, errorMsg]
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    maxFiles,
    accept,
    maxSize,
    multiple,
  });

  return (
    <div {...getRootProps()} className="mt-4 file-upload-wrapper">
      <input {...getInputProps()} />
      <div className="content-dragzone-div text-center d-flex align-items-center">
        <div className="upload-left-panel" data-testid="drag-and-drop-box">
          <div className="drag-drop-container">
            <div className="p-2">
              <UploadIcon />
            </div>
            <div>Drag and drop your {multiple || maxFiles > 1 ? 'files' : 'file'} here</div>
            <div data-testid="file-format-extensions">
              {fileFormatExtensionsText ? fileFormatExtensionsText : ''}
            </div>
          </div>
        </div>
        <div className="upload-right-panel" data-testid="browse-files-box">
          <div className="browse-files p-2">Browse Device</div>
        </div>
      </div>
      {infoMsg && <p className="text-muted mt-2 fw-normal lh-sm">{infoMsg}</p>}
    </div>
  );
};

export default FileUploadSection;
